import { createFileRoute } from "@tanstack/react-router";

import CompetitionOverview from "@/components/CompetitionOverview/CompetitionOverview";
import { CompetitionContextProvider } from "@/components/CompetitionOverview/CompetitionProvider";

const Component = () => {
  const competitionUuid = Route.useParams().competitionUuid;
  return (
    <CompetitionContextProvider collapseSelectorOnCompact>
      <CompetitionOverview competitionUuid={competitionUuid} />
    </CompetitionContextProvider>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid")({
  component: Component,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/events",
      },
    };
  },
});
